// extracted by mini-css-extract-plugin
export default {"helpText":"TopicUserSelect-module__helpText--upvFw","select":"TopicUserSelect-module__select--uafRN","animatedBackground":"TopicUserSelect-module__animatedBackground--YesjH"};